<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd conmon-top" style="margin-bottom: 10px;">
      <el-collapse-transition>
        <div class="search-content common-search-formtype" style="line-height: 48px;border: none">
          <div class="demo-input-suffix" style="text-align: left;margin-left: 32px">
            公众号切换：
            <el-select v-model="formInlineTmp.public_id" placeholder="请选择" clearable @change='getData'>
              <el-option
                v-for="item in publicNumber"
                :key="item.id"
                :label="item.nick_name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-flod-content search-content search-input-group common-search-formtype" style="padding: 0;border: none">
          <el-form :inline="true" :model="formInlineTmp" class="search-content-item" label-width="95px">
            <el-form-item label="活动类型：">
              <el-select @change="changeActivityTypes" filterable v-model="formInlineTmp.activity_id" placeholder="请选择">
                <el-option
                  v-for="item in activities"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场次名称：">
              <el-input clearable @keyup.enter.native="searchData" v-model.trim="formInlineTmp.nickname" placeholder="请输入场次名称"></el-input>
            </el-form-item>
            <el-form-item label="提交时间：">
              <el-date-picker
                class="micro-page-picker"
                style="width:350px!important;"
                v-model="timePickerDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                @blur="verifyTime"
                @change="see"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" class="search-btn-new" style="margin-right:32px" @click="downloadCustomer">导出</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        :data="tableData"
        v-loading="load"
        class="table">
        <el-table-column
          :label="item.label"
          v-for="(item, index) in headerList"
          :key="index"
          :fixed="(item.label === '提交时间') ? 'right' : false"
          :width="(item.label === '提交时间' || item.label === '创建时间' || item.label === '最后修改时间' || item.label === '客户') ? '180' : ''">
          <template slot-scope="scope">
            <div v-if="item.label === '客户'" style="display: flex;align-items: center">
              <img style="width: 40px;border-radius: 50%" :src="scope.row.avatar" alt="">
              <span style="margin-left: 10px">{{ scope.row[item.value] }}</span>
            </div>
            <div v-if="item.label === '场次名称'" class="activity-name">
              <el-popover trigger="hover" placement="top">
                {{ scope.row[item.value] }}
                <div slot="reference" class="name-wrapper">
                  <span class="link">{{ scope.row[item.value] }}</span>
                </div>
              </el-popover>
            </div>
            <div v-if="item.label !== '客户' && item.label !== '场次名称'">{{ scope.row[item.value] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getActivityStaticsActTypes, getActivityStaticsActRealList, activityStaticsActRealListDownload, getStructureList, deleteActivityList, addActivityQrcode, getWechatPublicListForNode, getActivityStatics } from '@/api/customer.js'
export default {
  name: 'fieldManage',
  data () {
    return {
      formInlineTmp: {},
      load: true,
      original_id: '',
      publicNumber: [],
      activities: [],
      timePickerDate: '',
      timeout: null,
      QrcodeDialog: false,
      QRViewDialog: false,
      isDisabled: false,
      QRImage: '',
      activity_id: 0,
      public_id: 0,
      addGradeForm: {
        grade: '',
        grade_list: []
      },
      addGradeDialog: false,
      formInline: {
        structure_id: '',
        public_id: '',
        nickname: '',
        activity_id: '',
        start_time: '',
        end_time: ''
      },
      form: {
        qrcode_name: '',
        activity_id: '',
        salesman_id: ''
      },
      qrcode_name: '',
      salesman_id: '',
      search: {
        qrcodes_salesman: '',
        start_time: '',
        end_time: ''
      },
      search_saleman: {
        public_id: ''
      },
      structureOptions: [],
      activitiess: [],
      salesmanOptions: [],
      hide: true,
      tableData: [],
      headerList: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      inGradeList: [],
      isSwitchClick: 1,
      activitie_id: ''
    }
  },
  methods: {
    see() {
      console.log('10101', this.timePickerDate)
      if (this.timePickerDate === null) {
        this.search.start_time = ''
        this.search.end_time = ''
      } else {
        this.search.start_time = this.timePickerDate[0]
        this.search.end_time = this.timePickerDate[1]
      }
    },
    searchData() {
      if (this.timePickerDate === null) {
        this.search.start_time = ''
        this.search.end_time = ''
      } else {
        this.search.start_time = this.timePickerDate[0]
        this.search.end_time = this.timePickerDate[1]
      }
      this.activitie_id = this.formInlineTmp.activity_id
      this.search.qrcodes_salesman = this.formInlineTmp.nickname
      this.page = 1
      this.getRealList()
    },
    // 切换公众号
    getData() {
      this.formInline.public_id = this.formInlineTmp.public_id
      this.tableData = []
      this.headerList = []
      this.loadData()
    },
    // 请求公众号
    getWechatPublicListForNodes() {
      getWechatPublicListForNode(1).then(res => {
        for (let item of res.data.data.list) {
          if (item.is_default === 1) {
            this.formInlineTmp.public_id = item.id
          }
        }
        this.publicNumber = res.data.data.list
        this.formInline.public_id = this.formInlineTmp.public_id
        this.loadData()
      })
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.salesmanOptions
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants
    },
    createStateFilter(queryString) {
      return (state) => {
        return state.name.indexOf(queryString) !== -1
      }
    },
    // 判断开始结束时间大小
    verifyTime() {
      console.log(this.timePickerDate)
      if (this.timePickerDate === null) {
        return
      }
      if (Date.parse(new Date(this.timePickerDate[0])) > Date.parse(new Date(this.timePickerDate[1]))) {
        _g.toastMsg('error', '开始时间不能大于结束时间')
      }
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.loadData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.activitie_id = this.formInlineTmp.activity_id
      // this.loadData()
      this.getRealList()
    },
    // 导出
    downloadCustomer() {
      if (this.totalCount === 0) {
        _g.toastMsg('error', '没有数据可导出')
        return
      }
      this.activitie_id = this.formInlineTmp.activity_id
      if (this.activitie_id === '') {
        _g.toastMsg('error', '请确保活动类型不为空')
        return
      }
      activityStaticsActRealListDownload(this.activitie_id, this.page, '', this.search).then((response) => {
        this.download(response)
      }).catch((error) => {
        _g.toastMsg('error', error)
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 切换活动类型
    changeActivityTypes() {
      this.tableData = []
      this.headerList = []
      this.activitie_id = this.formInlineTmp.activity_id
      this.getRealList()
    },
    // 获取具体列表
    getRealList() {
      getActivityStaticsActRealList(this.activitie_id, this.page, this.limit, this.search).then((res) => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
          for (let i in res.data.data.title) {
            if (res.data.data.title[i].label === '头像') {
              res.data.data.title.splice(i, 1)
            }
          }
          this.headerList = res.data.data.title
          this.totalCount = res.data.data.total
        } else {
          this.totalCount = 0
          this.tableData = []
        }
      })
    },
    // 列表数据
    loadData() {
      this.load = true
      // 获取活动类型
      let getWeChatActivityListForFiledsa = getActivityStaticsActTypes(this.formInline.public_id)
      // 获取具体列表
      // let getActivityStaticsActRealLists = getActivityStaticsActRealList(this.page, this.limit, this.search)
      // 发送promiss请求并处理
      Promise.all([getWeChatActivityListForFiledsa]).then(res => {
        // 获取活动类型列表查询
        if (res[0].data.code === 0) {
          // res[2].data.data.list.unshift({ '': '全部' })
          let arr = []
          for (let key in res[0].data.data.list) {
            arr.push({
              id: key,
              name: res[0].data.data.list[key]
            })
          }
          this.activities = arr
          this.formInlineTmp.activity_id = ''
          this.activitie_id = ''
          if (this.activities.length > 0) {
            this.formInlineTmp.activity_id = this.activities[0].id
            this.activitie_id = this.activities[0].id
            this.getRealList()
          } else {
            this.totalCount = 0
          }
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.load = false
      }, 500)
    }
  },
  created() {
    this.loading = true
    let limit_salesman = 0
    this.activity_id = this.$route.query.id
    this.formInline.activity_id = this.$route.query.id
    this.getWechatPublicListForNodes()
  }
}
</script>

<style scoped>
.name-wrapper {
  width: 90%;
  overflow: hidden;/*超出部分隐藏*/
  white-space: nowrap;/*不换行*/
  text-overflow:ellipsis;/*超出部分文字以...显示*/
}
</style>
